import { render, staticRenderFns } from "./TemplateBuilder.vue?vue&type=template&id=3a4bc7b4&scoped=true"
import script from "./TemplateBuilder.vue?vue&type=script&lang=js"
export * from "./TemplateBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4bc7b4",
  null
  
)

export default component.exports